var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_276_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1597 0V1.00343H12.4524V2.09274H11.1597V3.82904L10.0293 4.26782V2.09156H2.4231V9.86609H10.0293V8.54269L11.1597 8.18626V9.86962H12.4524V10.9589H11.1597V12.0012H10.0293V10.9589H2.4231V12.0012H1.29272V10.9589H0V9.86962H1.29272V2.09274H0V1.00343H1.29272V0H2.4231V1.00343H10.0293V0H11.1597ZM10.4626 5.44652C10.8752 5.91471 11.1658 6.41937 11.322 6.96402L14.6338 4.63484C14.9158 4.46309 15.0879 4.30546 14.9561 3.93608C14.8767 3.81963 14.7827 3.74787 14.6741 3.71964C14.5654 3.6914 14.4421 3.70787 14.3054 3.76904L10.4626 5.44652ZM5.48706 8.99677C6.48804 8.55799 7.76123 9.47437 8.52905 8.52505C8.73291 8.27331 8.84277 7.89687 8.77197 7.56867C8.7439 7.43574 8.68652 7.31222 8.59741 7.2087C8.55713 7.16283 8.51196 7.12048 8.45947 7.08166C7.80884 6.59935 6.95801 6.9405 6.43921 7.44751C5.96314 7.91452 5.6665 8.55446 5.48706 8.99677ZM8.844 6.75346C9.0332 6.90285 9.2688 7.22753 9.27734 7.53573L11.04 7.10048C10.8679 6.50172 10.6006 5.96647 10.1721 5.54181C9.51782 6.11352 9.56299 6.2288 8.844 6.75346ZM6.9397 5.41829L5.5127 6.91697V4.63954H4.1687V3.4973H8.28369V4.63954H6.9397V5.41829Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_276_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingLogo);
export default __webpack_public_path__ + "static/media/branding-logo.4c4da2e8161bf98d162c83fa29f6f62e.svg";
export { ForwardRef as ReactComponent };